var OrderStatusEnum = /* @__PURE__ */ ((OrderStatusEnum2) => {
  OrderStatusEnum2["PROCESSING"] = "processing";
  OrderStatusEnum2["PENDING_PAYMENT"] = "pending_payment";
  OrderStatusEnum2["ON_HOLD"] = "holded";
  OrderStatusEnum2["OPEN"] = "open";
  OrderStatusEnum2["PENDING"] = "pending";
  OrderStatusEnum2["CONFIRMED"] = "confirmed";
  OrderStatusEnum2["SHIPPED"] = "shipped";
  OrderStatusEnum2["COMPLETE"] = "complete";
  OrderStatusEnum2["CANCELED"] = "canceled";
  return OrderStatusEnum2;
})(OrderStatusEnum || {});
export {
  OrderStatusEnum
};
